import { useRollbar } from '@rollbar/react'
import { Ace } from 'ace-builds'
import axios, { AxiosError } from 'axios'
import { useState } from 'react'

const DEFAULT_IGNORED_ANNOTATIONS = [
  'in the frameset phase. Ignored.',
  'Expected e.g. <!DOCTYPE html>.',
  'Unexpected end tag (noscript). Ignored.',
  'Named entity expected. Got none.',
]

export const useAceAnnotations = () => {
  const [annotations, setAnnotations] = useState<Ace.Annotation[]>([])
  const [hasError, setHasError] = useState(false)
  const rollbar = useRollbar()
  const [isLoading, setIsLoading] = useState(false)

  const handleValidate = (incoming: Ace.Annotation[]) => {
    setHasError(false)
    const filtered = incoming.filter(annotation => {
      return !DEFAULT_IGNORED_ANNOTATIONS.some(ignore =>
        annotation.text.includes(ignore),
      )
    })

    setAnnotations(prev => {
      if (
        prev.length === filtered.length &&
        prev.every(
          (a, i) =>
            a.row === filtered[i].row &&
            a.column === filtered[i].column &&
            a.text === filtered[i].text &&
            a.type === filtered[i].type,
        )
      ) {
        return prev
      }
      return filtered
    })
  }

  const validatehtml = async (value: string) => {
    try {
      setIsLoading(true)
      await axios.post(`/api/dashboard/page-editor/validate-html`, {
        html: value,
      })

      setIsLoading(false)
    } catch (e) {
      if (e instanceof AxiosError && e.status !== 422) {
        rollbar.error('validate-html failed before validating', e)
        setHasError(true)
      }
      setIsLoading(false)
      throw new Error(`validate-html failed before validating`)
    }
  }
  const isValid = annotations.length === 0

  return {
    annotations,
    handleValidate,
    isValid,
    validatehtml,
    isLoading,

    hasHtmlError: hasError,
  }
}
